import "//shopakaso.com/cdn/shop/t/25/assets/alpine-store-product.js?v=106176092735348342261780911785"
import { LiquidData } from "//shopakaso.com/cdn/shop/t/25/assets/goc-shopify-liquid.js?v=1535706865730436261780911842"

function formatVariantMoney(price) {
  if (price == null) {
    return ""
  }
  if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
    return Shopify.formatMoney(price)
  }
  return (price / 100).toFixed(2)
}

function readBuyBottomConfig() {
  const configEl = document.querySelector("[id^='ProductBuyBottomData-']")
  if (!configEl) {
    return null
  }
  try {
    return JSON.parse(configEl.textContent)
  } catch (error) {
    console.error(error)
    return null
  }
}

function getVariantIdFromUrl() {
  try {
    const url = new URL(window.location.href)
    return url.searchParams.get("variant")
  } catch (e) {
    return null
  }
}

function main() {
  Alpine.data("productBuyBottom", function () {
    return {
      config: null,
      productTitle: "",
      variants: [],

      get product() {
        if (this.$store.product?.data) {
          return this.$store.product.data
        }
        if (!this.config) {
          return null
        }
        return {
          id: this.config.productId,
          title: this.config.productTitle,
          url: this.config.productUrl,
          variants: this.variants,
          featured_image: this.config.featuredImage,
        }
      },

      get title() {
        return this.product?.title || this.productTitle || ""
      },

      get variantTitle() {
        return this.variant?.title || ""
      },

      getVariantImageUrl(variant, product) {
        const image =
          variant?.featured_image ||
          variant?.featured_media?.preview_image ||
          variant?.featured_media ||
          product?.featured_image

        if (!image) {
          return null
        }

        if (typeof image === "string") {
          return image
        }

        return image.src || image.preview_image?.src || image.url || null
      },

      get variantImg() {
        if (!this.variant && !this.product) {
          return null
        }
        return this.getVariantImageUrl(this.variant, this.product)
      },

      get isSoldOut() {
        const activeVariant =
          this.variant ||
          this.resolveVariant(this.config?.selectedVariantId) ||
          this.resolveVariant(LiquidData.selectedVariant())

        if (!activeVariant) {
          return false
        }
        return activeVariant.available === false
      },

      init() {
        this.config = readBuyBottomConfig()
        this.productTitle = this.config?.productTitle || ""
        this.variants = this.config?.variants || window.productData?.variants || []

        const selectedVariant =
          this.resolveVariant(LiquidData.selectedVariant()) ||
          this.resolveVariant(this.config?.selectedVariantId)

        if (selectedVariant) {
          this.applyVariant(selectedVariant, { skipPrice: true })
        }

        this.startVariantWatcher()
        this.registerPublicReceiver()
        this.setupVariantSync()
        this.syncVariantFromDom()
        this.updatePriceFromDom()

        this.$watch("product", (product) => {
          if (!product?.variants?.length) {
            return
          }
          this.variants = product.variants
          if (!this.variant) {
            this.syncVariantFromDom()
          }
          this.updatePrice()
        })
      },

      variant: null,
      price: "",
      originalPrice: "",
      hasSubscribedVariantChange: false,
      variantPickerEl: null,
      documentChangeHandler: null,
      variantWatcherTimer: null,
      lastSeenVariantId: null,

      getVariantPicker() {
        const productUrl = this.$el?.dataset?.productUrl
        if (productUrl) {
          const picker = document.querySelector(`variant-selects[data-url="${productUrl}"]`)
          if (picker) {
            return picker
          }
        }
        return (
          this.variantPickerEl ||
          document.querySelector("variant-selects[data-section]")
        )
      },

      startVariantWatcher() {
        // 兜底：有些主题/浏览器下 module 无法稳定拿到 pubsub/自定义事件
        // 这里仅做“读 DOM → 若变体 id 变化则更新底部栏”，不影响产品区主流程
        if (this.variantWatcherTimer) {
          return
        }
        this.variantWatcherTimer = window.setInterval(() => {
          try {
            const picker = this.getVariantPicker()
            const checkedRadio = this.getCheckedVariantRadio(picker)
            const idFromRadio = checkedRadio?.dataset?.id
            const idFromPicker = picker?.currentVariant?.id
            const idFromHiddenInput = document.querySelector(
              `#product-form-${picker?.dataset?.section || ""} input[name="id"], form[data-type="add-to-cart-form"] input[name="id"]`
            )?.value
            const idFromUrl = getVariantIdFromUrl()
            const nextId = idFromUrl || idFromHiddenInput || idFromRadio || idFromPicker
            if (!nextId) {
              return
            }
            if (String(this.lastSeenVariantId) === String(nextId)) {
              return
            }
            this.lastSeenVariantId = nextId
            const nextVariant = this.resolveVariant(nextId) || picker?.currentVariant
            if (nextVariant) {
              this.applyVariant(nextVariant, { skipPrice: true })
              this.updatePriceFromDom()
            }
          } catch (e) {
            // watcher 是兜底，不应抛错影响页面
            console.error(e)
          }
        }, 250)
      },

      getVariantsList() {
        if (this.product?.variants?.length) {
          return this.product.variants
        }
        if (this.variants?.length) {
          return this.variants
        }
        const picker = this.getVariantPicker()
        if (picker && typeof picker.getVariantData === "function") {
          return picker.getVariantData()
        }
        return window.productData?.variants || []
      },

      resolveVariant(variantOrId) {
        if (!variantOrId) {
          return null
        }
        if (typeof variantOrId === "object") {
          return variantOrId
        }
        const variants = this.getVariantsList()
        if (!variants?.length) {
          return null
        }
        return variants.find((item) => String(item.id) === String(variantOrId)) || null
      },

      getCheckedVariantRadio(picker) {
        if (!picker) {
          return null
        }
        return picker.querySelector('input[type="radio"][data-id]:checked')
      },

      registerPublicReceiver() {
        const component = this
        window.AkasoProductBuyBottom = {
          receive(payload) {
            component.receivePublicVariant(payload)
          },
        }
      },

      receivePublicVariant(payload) {
        if (!payload?.variant) {
          return
        }
        this.applyVariant(payload.variant, { skipPrice: true })
        if (payload.html && payload.sectionId) {
          this.syncPriceFromVariantHtml(payload.html, payload.sectionId)
        }
      },

      syncVariantFromDom() {
        const picker = this.getVariantPicker()
        const checkedRadio = this.getCheckedVariantRadio(picker)

        const variantIdFromUrl = getVariantIdFromUrl()
        if (variantIdFromUrl) {
          const variantFromUrl = this.resolveVariant(variantIdFromUrl)
          if (variantFromUrl) {
            this.applyVariant(variantFromUrl)
            this.updatePriceFromDom()
            return
          }
        }

        const variantIdInput = document.querySelector(
          `#product-form-${picker?.dataset?.section || ""} input[name="id"], form[data-type="add-to-cart-form"] input[name="id"]`
        )
        if (variantIdInput?.value) {
          const variant = this.resolveVariant(variantIdInput.value)
          if (variant) {
            this.applyVariant(variant)
            this.updatePriceFromDom()
            return
          }
        }

        if (checkedRadio?.dataset?.id) {
          const variantByRadio = this.resolveVariant(checkedRadio.dataset.id)
          if (variantByRadio) {
            this.applyVariant(variantByRadio)
            this.updatePriceFromDom()
            return
          }
        }

        if (picker?.currentVariant) {
          this.applyVariant(picker.currentVariant)
          this.updatePriceFromDom()
          return
        }

        // (hidden input 已在上方优先处理)
      },

      applyVariant(variant, options = {}) {
        const resolved = this.resolveVariant(variant)
        if (!resolved) {
          return
        }
        this.variant = { ...resolved }
        this.updateBssVariantId(resolved.id)
        if (resolved.price != null) {
          this.price = formatVariantMoney(resolved.price)
        }
        if (!options.skipPrice) {
          this.updatePrice()
        }
      },

      updateBssVariantId(variantId) {
        const bssLine = document.querySelector("[bss-b2b-order-list-total-line]")
        if (bssLine && variantId) {
          bssLine.setAttribute("bss-b2b-order-list-total-line", variantId)
        }
      },

      syncPriceFromVariantHtml(html, sectionId) {
        if (!html || !this.product?.id || !sectionId) {
          return
        }
        const source = html.getElementById(`price-${sectionId}`)
        if (!source) {
          return
        }
        const gocPrice = source.querySelector(`#goc-price-${this.product.id}`)
        const priceText = (gocPrice || source.querySelector(".price-item--regular"))?.textContent
        if (priceText) {
          this.price = priceText.trim()
        }
      },

      handleExternalVariantChange(event) {
        if (!event?.data?.variant) {
          return
        }
        this.receivePublicVariant({
          variant: event.data.variant,
          sectionId: event.data.sectionId,
          html: event.data.html,
        })
      },

      setupVariantSync() {
        if (this.hasSubscribedVariantChange) {
          return
        }
        this.hasSubscribedVariantChange = true

        const pubSub = window.PUB_SUB_EVENTS
        const subscribeFn = window.subscribe || (typeof subscribe === "function" ? subscribe : null)

        if (pubSub && subscribeFn) {
          subscribeFn(pubSub.variantChange, (event) => this.handleExternalVariantChange(event))
          subscribeFn(pubSub.quantityChange, (event) => {
            const nextVariant = this.resolveVariant(event?.data?.variant)
            if (nextVariant) {
              this.applyVariant(nextVariant)
            }
          })
        }

        this.documentChangeHandler = (domEvent) => {
          const target = domEvent.target
          if (!target) {
            return
          }

          const inVariantPicker =
            target.closest?.("variant-selects") ||
            target.closest?.(".product-form__input--pill") ||
            target.matches?.('input[type="radio"][data-id]') ||
            target.matches?.('input[name^="options"]') ||
            target.matches?.('select[name^="options"]')

          if (!inVariantPicker && !target.matches?.('input[name="id"]')) {
            return
          }

          window.requestAnimationFrame(() => {
            this.syncVariantFromDom()
          })
        }

        document.addEventListener("change", this.documentChangeHandler)

        this.akasoVariantChangeHandler = (event) => {
          this.receivePublicVariant(event?.detail || {})
        }
        document.addEventListener("akaso:variant-change", this.akasoVariantChangeHandler)

        this.bindVariantPicker()
        window.addEventListener("load", () => this.bindVariantPicker())
      },

      bindVariantPicker() {
        const picker = this.getVariantPicker()
        if (!picker) {
          return
        }
        this.variantPickerEl = picker

        if (picker.dataset.buyBottomBound !== "true") {
          picker.dataset.buyBottomBound = "true"
          picker.addEventListener("change", () => {
            if (picker.currentVariant) {
              this.applyVariant(picker.currentVariant)
            } else {
              this.syncVariantFromDom()
            }
          })
        }
      },

      updatePriceFromDom() {
        const productId = this.product?.id || this.config?.productId
        if (!productId) {
          return
        }
        if (this.variant?.price != null) {
          this.price = formatVariantMoney(this.variant.price)
          return
        }

        const gocPrice = document.querySelector("#goc-price-" + productId)
        if (gocPrice && gocPrice.textContent) {
          this.price = gocPrice.textContent.trim()
        }
      },

      async updatePrice() {
        const productId = this.product?.id || this.config?.productId
        if (!productId) {
          return
        }
        this.updatePriceFromDom()
        try {
          this.originalPrice = await LiquidData.updatePrice()
        } catch (error) {
          console.error(error)
        }
      },

      backToTop() {
        document.documentElement.scrollTop = 0
      },

      currActiveIndex: "",
      clickAddToCart(secId) {
        this.currActiveIndex = secId
        const picker = this.getVariantPicker()
        const sectionId = picker?.dataset?.section
        const buttonIds = [
          sectionId && `ProductSubmitButton-${sectionId}`,
          secId && `ProductSubmitButton-${secId}__seemor-product`,
          secId && `ProductSubmitButton-${secId}__main`,
        ].filter(Boolean)

        let buttonToTrigger = null
        for (const buttonId of buttonIds) {
          buttonToTrigger = document.getElementById(buttonId)
          if (buttonToTrigger) {
            break
          }
        }

        if (buttonToTrigger) {
          buttonToTrigger.click()
        } else {
          console.error(`Add to cart button not found: ${buttonIds.join(", ")}`)
        }
      },

      cartAction: throttle(function (e) {
        if (!this.isSoldOut) {
          e.stopPropagation()
          this.handleCart()
        }
      }, 2000),
    }
  })
}

// 兼容：module 可能晚于 alpine:init 加载
if (window.Alpine && typeof window.Alpine.data === "function") {
  main()
} else {
  document.addEventListener("alpine:init", main)
}
